import React, { useContext } from 'react'
import moment from 'moment'
import { Text, View } from 'oio-react'
import InitiativeJoinButton from 'src/apps/Initiative/components/JoinButton'
import InitiativeMoreButton from 'src/apps/Initiative/components/MoreButton'
import InitiativeTypeLabel from 'src/apps/Initiative/components/TypeLabel'
import { useOrganization } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import ThemeContext from 'src/libraries/contexts/Theme'
import CoverMedia from '~/components/CoverMedia'

const InitiativeCoverA = () => {
   const theme = useContext(ThemeContext)
   const textColor = theme.tmpContentTextColor

   const { initiative } = useContext(InitiativeHierarchyContext)
   const { organization } = useOrganization()
   const isBleedingEdge = organization.gatherAppVersion === 6
   const { highlightColor: buttonColor } = organization.theme

   const isEventOrGroup = ['event', 'group'].includes(initiative.class)
   const primaryRole = initiative.roles.find(r => r.type === 'primary')
   const showNumMembers = isEventOrGroup && primaryRole.numActiveUsers > 5
   let buttonAlignment = 'flex-end'

   if (showNumMembers) {
      buttonAlignment = 'space-between'
   } else if (isEventOrGroup) {
      buttonAlignment = 'center'
   }

   return (
      <View
         display="flex"
         alignItems="center"
         flexFlow="column"
         backgroundColor={theme.tmpContentBackgroundColor}
         minHeight="100vh[e-f]"
         height="100%"
         padding={isBleedingEdge
            ? '30px 20px[a] 30px 40px[b] 30px 0px[c-d] 40px[e-f]'
            : '30px 0px 0px 0px[a-c] 30px 30px 0px 0px[d] 30px 40px 0px 0px[e-f]'
         }>
         <View
            width="100%"
            textAlign="center"
            maxWidth={isBleedingEdge && '550px[a-d]'}>
            {initiative.eventIsVirtual && (
               <Text
                  size={theme.tmpBodyTextSize}
                  lineHeight="150%"
                  color="#eb8044">
                  Online Event
               </Text>
            )}
            {!initiative.eventIsVirtual && <InitiativeTypeLabel />}
            <View marginTop="10px">
               <Text
                  color={textColor}
                  size="9[a-d] 10[e-f]"
                  letterSpacing="-0.5px">
                  {initiative.name}
               </Text>
            </View>
            {initiative.startDateTimeISO8601 && (
               <View marginTop="10px" opacity="0.5">
                  <Text
                     color={textColor}
                     size={theme.tmpBodyTextSize}
                     lineHeight={theme.tmpBodyTextLineHeight}>
                     {moment(initiative.startDateTimeISO8601).format('MMMM Do, YYYY')}
                  </Text>
               </View>
            )}
            {initiative.subtitle && (
               <View
                  display="inline-block"
                  maxWidth={initiative.subtitle.length < 100 && '400px'}
                  marginTop="20px"
                  opacity="0.6">
                  <Text
                     color={textColor}
                     size="3"
                     lineHeight={theme.tmpBodyTextLineHeight}>
                     {initiative.subtitle}
                  </Text>
               </View>
            )}
            {(isEventOrGroup || initiative.currentUserCanEdit) && (
               <View
                  display="block"
                  width="100%"
                  marginTop="20px[a-b] 30px[c-f]"
                  marginBottom="20px[a-b] 30px[c-f]"
                  borderTop="1px solid #e5e5e5"
               />
            )}
            <View
               display="flex"
               justifyContent={buttonAlignment}
               alignItems="center"
               flexFlow="column[a-b] row[c-f]">
               {showNumMembers && (
                  <View paddingBottom="20px[a-b]" opacity="0.5">
                     <Text
                        color={textColor}
                        size={theme.tmpSubBodyTextSize}
                        lineHeight="160%">
                        {`${primaryRole.numActiveUsers} people are attending this event`}
                     </Text>
                  </View>
               )}
               <View display="flex" width="100%[a-b]">
                  {initiative.joinable && (
                     <View flex="1 1 auto">
                        <InitiativeJoinButton
                           buttonSize="lg"
                           buttonWidth="100%"
                        />
                     </View>
                  )}
                  <InitiativeMoreButton
                     buttonSize="lg"
                     color={buttonColor}
                     iconColor="#fff"
                  />
               </View>
            </View>
         </View>
         <View
            maxWidth={isBleedingEdge && '550px[a-d]'}
            width="100%"
            paddingTop="20px[a-b] 30px[c-f]">
            <CoverMedia />
         </View>
      </View>
   )
}

export default InitiativeCoverA
